var map = {
	"./label_1.svg": 5851,
	"./label_10.svg": 3465,
	"./label_11.svg": 3991,
	"./label_12.svg": 1065,
	"./label_13.svg": 8265,
	"./label_14.svg": 2538,
	"./label_15.svg": 4375,
	"./label_16.svg": 3531,
	"./label_17.svg": 4002,
	"./label_18.svg": 5150,
	"./label_19.svg": 1520,
	"./label_2.svg": 8208,
	"./label_20.svg": 6550,
	"./label_21.svg": 324,
	"./label_22.svg": 7304,
	"./label_3.svg": 6653,
	"./label_4.svg": 7091,
	"./label_5.svg": 9295,
	"./label_6.svg": 1557,
	"./label_7.svg": 2585,
	"./label_8.svg": 3521,
	"./label_9.svg": 2445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4743;